import React from 'react';

// PARTNER-TYPO-EINHEIT-001: DER eine Seitenkopf für alle Partner-Seiten (Methode aus dem Admin-Portal).
// Titel + optionale Beschreibung links, optionale Aktionen rechts — Stile zentral
// in index.css (.vg-page-head, Titelgröße NUR --vg-fs-title). Bewusst OHNE Vorzeile:
// den Kontext „Operations Center · Admin · <Seite>" zeigt bereits die sticky
// Kopfleiste; die frühere Dreifach-Nennung (Kopfleiste + Vorzeile + h1) ist damit weg.
export default function PageHeader({ title, description, actions }) {
  return (
    <header className="vg-page-head">
      <div className="vg-page-head-text">
        <h1>{title}</h1>
        {description ? <p className="vg-page-head-desc">{description}</p> : null}
      </div>
      {actions ? <div className="vg-page-head-actions">{actions}</div> : null}
    </header>
  );
}
